export const timeouts = {
    short: 4000,
    long: 8000,
};
export const positions = [
    "top-start",
    "top",
    "top-end",
    "bottom-start",
    "bottom",
    "bottom-end",
];
const defaultPositionData = positions.reduce((acc, cur) => ({ [cur]: [], ...acc }), {});
export const defaultContextData = {
    queues: defaultPositionData,
    show: () => { },
    hide: () => { },
    remove: () => { },
    add: () => "",
};
